import { useContext } from "react";
import { MenuContext } from "../../contexts/MenuContext";

export default function TopbarArea({ children }) {
    const menuCtx = useContext(MenuContext);

    return (<div className={"mx-auto transition-all duration-500 " + (menuCtx.sidebarMenu ? 'md:ml-20' : 'md:ml-72')}>
            {children}
    </div>);
}